"use client";
import React from "react";
const PlusIconSvg = () => {
  return (
    <svg
      className="cursor-pointer"
      width="7"
      height="20"
      viewBox="0 0 7 20"
      fill="none"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        data-testid="plus-icon-path"
        d="M6.55756 10.508H4.31356V12.788H2.68156V10.508H0.437563V8.96H2.68156V6.668H4.31356V8.96H6.55756V10.508Z"
        fill="#3460DC"
      />
    </svg>
  );
};

export default PlusIconSvg;
